<template>
  <div class="row my-1">
    <div class="py-0 ma-0 col-12 fs-14 text-white" v-html="html"></div>
  </div>
</template>

<script>
export default {
  name: "HtmlToast",
  data: () => ({}),
  props: {
    html: { type: String, default: "" },
  },
};
</script>

<style>
.new-link-alert {
  display: inline !important;
  color: #fffffe !important;
  font-weight: bold !important;
  text-decoration: underline !important;
}
</style>
